export class Charts {
    public static readonly Line = 'line';
    public static readonly Bar = 'bar';
    public static readonly Radar = 'radar';
    public static readonly Pie = 'pie';
    public static readonly PolarArea = 'polarArea';
    public static readonly Doughnut = 'doughnut';
}
